/**
 * Operation Log / Operation Log Rules toolbar only.
 * Do not import from other features � keeps InputField default behavior untouched.
 */

/** Narrower than MUI size="small" contained button (~30.75). */
export const TOOLBAR_INPUT_HEIGHT = 26;

/**
 * Top padding above InputBase. MUI outlined shrink default y=-9 when InputBase top=0;
 * with this pad, shrink y = TOOLBAR_LABEL_SLOT - 9.
 */
export const TOOLBAR_LABEL_SLOT = 14;

const toolbarShrinkLabelTransform = `translate(14px, ${TOOLBAR_LABEL_SLOT - 9}px) scale(0.75)`;

/** Toolbar filter InputField sx � pair with toolbarFilterLabelProps. */
export const toolbarFilterFieldSx = {
    flexShrink: 0,
    pt: `${TOOLBAR_LABEL_SLOT}px`,
    overflow: 'visible',
    '& .MuiInputBase-root': {
        height: `${TOOLBAR_INPUT_HEIGHT}px !important`,
        minHeight: `${TOOLBAR_INPUT_HEIGHT}px !important`,
        boxSizing: 'border-box' as const,
        overflow: 'visible',
    },
    '& .MuiInputBase-input, & .MuiSelect-select': {
        py: '2px !important',
        boxSizing: 'border-box' as const,
    },
    '& .MuiInputLabel-root, & .MuiInputLabel-root.MuiInputLabel-shrink': {
        transform: toolbarShrinkLabelTransform,
    },
    '& .MuiOutlinedInput-notchedOutline legend': {
        maxWidth: '100%',
    },
};

/** Always-shrunk label aligned to shortened toolbar InputBase. */
export const toolbarFilterLabelProps = {
    shrink: true as const,
    sx: {
        maxWidth: 'none',
        overflow: 'visible',
        textOverflow: 'clip',
        whiteSpace: 'nowrap' as const,
        backgroundColor: 'background.paper',
        px: 0.5,
        zIndex: 2,
        lineHeight: 1.2,
        transform: toolbarShrinkLabelTransform,
    },
};
